import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { BarChart3, LayoutDashboard, Ship, Menu, X } from "lucide-react";
import { Drawer, Button } from "antd";

const adminmenu = [
  {
    id: 3,
    label: "Ships",
    path: "/superadmin/ship-register",
    icon: <Ship />,
  },
  {
    id: 1,
    label: "Module Builder",
    path: "/superadmin/module-builder",
    icon: <LayoutDashboard />,
  },
  {
    id: 4,
    label: "Charts",
    path: "/superadmin/chart-management",
    icon: <BarChart3 />,
  },
  {
    id: 5,
    label: "Events",
    path: "/superadmin/event-management",
    icon: <BarChart3 />,
  },
];

const Navbar = () => {
  const { role } = useAuth();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  let menuItems = [];
  if (role === "SUPERADMIN") {
    menuItems = adminmenu;
  }

  const NavItems = ({ isMobile = false }) => (
    <>
      {menuItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          onClick={() => isMobile && setMobileNavOpen(false)}
          className={({ isActive }) =>
            `d-flex align-items-center gap-2 fw-semibold text-decoration-none 
             ${
               isActive
                 ? "text-success border-2 border-success fw-bold"
                 : "text-secondary"
             } ${isMobile ? "py-3 px-2" : ""}`
          }
          style={{
            fontSize: isMobile ? "16px" : "14px",
            transition: "color 0.2s ease, border-color 0.2s ease",
            borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
          }}
        >
          {({ isActive }) => (
            <>
              {item.icon &&
                React.cloneElement(item.icon, {
                  size: isMobile ? 20 : 16,
                  className: isActive ? "text-success" : "text-muted",
                })}
              {item.label}
            </>
          )}
        </NavLink>
      ))}
    </>
  );

  return (
    <>
      {/* Desktop Navigation */}
      <div className="d-none d-lg-flex ms-4 gap-4" style={{ height: "25px" }}>
        <NavItems />
      </div>

      {/* Mobile Navigation Button */}
      <div className="d-flex d-lg-none ms-3">
        <Button
          type="text"
          icon={<Menu size={20} />}
          onClick={() => setMobileNavOpen(true)}
          style={{ padding: "4px 8px" }}
        />
      </div>

      {/* Mobile Navigation Drawer */}
      <Drawer
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span className="fw-bold text-success">Navigation</span>
            <Button
              type="text"
              icon={<X size={20} />}
              onClick={() => setMobileNavOpen(false)}
            />
          </div>
        }
        placement="left"
        closable={false}
        onClose={() => setMobileNavOpen(false)}
        open={mobileNavOpen}
        width={280}
        bodyStyle={{ padding: "0" }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <NavItems isMobile={true} />
        </div>
      </Drawer>
    </>
  );
};

export default Navbar;